import React, { useCallback, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useAuth } from '../context/AuthContext';
import Seo from '../components/seo/Seo';
import { useConfig } from '../utils/useConfig';

function ConfirmEmail() {
  const config = useConfig();

  const { token } = useParams<{ token: string }>();

  const { confirmEmail } = useAuth();
  const [confirmed, setConfirmed] = React.useState(false);

  const navigate = useNavigate();

  const confirmEmailHandler = useCallback(async () => {
    if (!token) {
      navigate(-1);
      toast.error('Nieprawidłowy adres');
      return;
    }
    try {
      await confirmEmail(token);
      toast.success('Adres email został potwierdzony!');
      setConfirmed(true);
    } catch (error: Error | any) {
      console.error('Email confirmation failed', error);
      toast.error(error.message);
    }
  }, [confirmEmail, navigate, token]);

  useEffect(() => {
    if (token) {
      confirmEmailHandler();
    } else {
      navigate('/');
      toast.error('Nieprawidłowy adres');
    }
  }, [confirmEmailHandler, navigate, token]);

  return (
    <>
      <div className="w-full flex flex-col items-center">
        {confirmed ? (
          <div className="mt-6">
            <h2 className="text-3xl font-bold mb-4">
              Adres email został potwierdzony. Możesz się teraz zalogować
            </h2>
            <Link to="/logowanie" className="underline">
              Wróć do logowania
            </Link>
          </div>
        ) : (
          <p className="text-red-500">Potwierdzanie adresu email...</p>
        )}
      </div>
      <Seo
        title={`Potwierdzenie adresu email`}
        description="Potwierdź swój adres email, aby zakończyć rejestrację. Sprawdź swoją skrzynkę pocztową i kliknij w link potwierdzający."
        image={config.company.logo}
        noindex={true}
      />
    </>
  );
}

export default ConfirmEmail;
